import { render, staticRenderFns } from "./ExchangeAgentSelectDialog.vue?vue&type=template&id=5cbbf540&"
import script from "./ExchangeAgentSelectDialog.vue?vue&type=script&lang=js&"
export * from "./ExchangeAgentSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbbf540')) {
      api.createRecord('5cbbf540', component.options)
    } else {
      api.reload('5cbbf540', component.options)
    }
    module.hot.accept("./ExchangeAgentSelectDialog.vue?vue&type=template&id=5cbbf540&", function () {
      api.rerender('5cbbf540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/ExchangeAgentSelectDialog.vue"
export default component.exports